import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const ApprovalActionsService = {
    creators: async () => axios.get(`${API_URL}/approval_actions/creators`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
    evaluators: async () => axios.get(`${API_URL}/approval_actions/evaluators`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err })
};

export default ApprovalActionsService;